import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./app/store";
import { MsalProvider, MsalAuthenticationTemplate } from "@azure/msal-react";
import { pca, authRequest } from "./utils/auth/authConfig";
import AuthError from "./routes/AuthError";
import AuthLoading from "./routes/AuthLoading";
import { InteractionType } from "@azure/msal-browser";
import { ThemeProvider } from "@material-ui/styles";
import { transnetTheme } from "./assets/scss/transnetTheme";
import { CssBaseline } from "@material-ui/core";
import { LicenseInfo } from "@mui/x-license-pro";

LicenseInfo.setLicenseKey(
  "01b05a16469e707bbdc0fd5299939ec1Tz03MDYyNCxFPTE3MjA4ODA1NTcwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y"
);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={transnetTheme}>
        <CssBaseline />
        <MsalProvider instance={pca}>
          <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
            authenticationRequest={authRequest}
            errorComponent={AuthError}
            loadingComponent={AuthLoading}
          >
            <App />
          </MsalAuthenticationTemplate>
        </MsalProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// expose store during tests
if (window.Cypress) {
  window.store = store;
}
